<template>
  <div class="send">
    <div class="send__container">
      <div class="send__header">
        <div class="send__title">{{resource('sendOpenOrdersAndLists')}}</div>
        <button
          class="button--no send__close"
          @click="close()"
        >
          <icon name="close" />
        </button>
      </div>
      <div class="send__content">
        <sendOrderItem
          class="orders-list__item"
          :order="order"
          @sent="updateOrderList($event)"
          v-for="(order) in ordersList"
          :key="order.id"
        />
        <div
          class="send__empty empty"
          v-if="!ordersList.length"
        >
          <icon
            name="sendOrders"
            class="empty__icon"
            :size="27"
          />
          <div class="empty__text">{{resource('empty')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.send {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: $overlay;
  display: flex;
  justify-content: center;
  align-items: stretch;
  padding: $container;
  box-sizing: border-box;
  z-index: 2;
  &__container {
    background: $overlay__bg;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
  &__title {
    font-size: $h1;
    font-weight: bold;
  }
  &__header {
    padding: $content;
    flex: 0 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: $send-header__bg;
    color: $send-header__color;
  }
  &__content {
    overflow: auto;
    flex: 1 1 auto;
  }
}
.empty {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  &__icon {
    margin-bottom: 1em;
  }
  &__text {
    font-size: 18px;
    font-weight: bold;
    color: #212121;
  }
}
</style>
<script>
import sendOrderItem from '@/components/app-sendOrderItem.vue'

export default {
	name: 'sendOrders',
	components: {
		sendOrderItem
	},
	computed: {
		openOrders () {
			return this.$store.state.orders
		}
	},
	methods: {
		resource (item) {
			var lang = this.$store.getters.language
			return this.res[lang][item]
		},
		close () {
			this.$emit('close')
		},
		removeOrder (id) {
			this.$store.commit('removeOrder', id)
		},
		updateOrderList (id) {
			// make new list
			var list = this.openOrders
			var index = list.findIndex(i => {
				return i.id === id
			})
			// if the list is empty make a new order
			if (this.$store.getters.getOrderList.length <= 1) {
				// go to add order
				this.$router.push({ name: 'AddOrder' })
				this.$store.commit('removeOrder', id)
			}
			// active order is sent
			else if (id === this.$store.state.app.activeOrder) {
				if (list.length > index + 1) {
					// not the latest item, so set active item to last item
					this.$store.commit('setActiveOrder', list[list.length - 1].id)
					this.$store.commit('removeOrder', id)

				} else {
					// latest item, so set active item first to last
					this.$store.commit('setActiveOrder', list[list.length - 2].id)
					this.$store.commit('removeOrder', id)

				}
			} else {
				this.$store.commit('removeOrder', id)
			}
		}
	},
	data () {
		return {
			res: {
				nl: {
					sendOpenOrdersAndLists: 'Verstuur open orders en bestellijsten',
					empty: 'Er zijn geen open orders'
				},
				fr: {
					sendOpenOrdersAndLists: 'Envoyer des commandes ouvertes et des listes de commandes',
					empty: 'Il n\'y pas de commandes ouvertes'
				}
			},
			ordersList: this.$store.state.orders.filter(order => {
				// this is not computed, because message in order should be shown when sent
				return order.cart.length > 0
			})
		}
	}
}
</script>
